import {
  AdminDashboard,
  AgronomistDetail,
  AgronomistManagement,
  ChangePassword,
  ContentManagement,
  CropManagement,
  CropPlanDetail,
  CropPlanManagement,
  GrowerDetail,
  GrowerManagement,
  Login,
  ProductManagement,
  ProfileScreen,
  ScoutingDetail,
  ScoutingManagement,
  SplashScreen,
} from "#pages";

const AdminBaseURL = "/admin";

const AdminRoutePath = {
  SPLASH: {
    accessible: true,
    component: <SplashScreen />,
    exact: true,
    path: `${AdminBaseURL}/splash`,
    title: "Login Page",
    type: "non-private",
  },
  LOGIN: {
    accessible: true,
    component: <Login />,
    exact: true,
    path: `${AdminBaseURL}/login`,
    title: "Login Page",
    type: "non-private",
  },
  PROFILE: {
    accessible: true,
    component: <ProfileScreen />,
    exact: true,
    path: `${AdminBaseURL}/profile`,
    title: "Profile Page",
    type: "non-private",
  },
  CHANGE_PASSWORD: {
    accessible: true,
    component: <ChangePassword />,
    exact: true,
    path: `${AdminBaseURL}/change-password`,
    title: "Change Password Page ",
    type: "non-private",
  },

  DASHBOARD: {
    accessible: true,
    component: <AdminDashboard />,
    exact: true,
    path: `${AdminBaseURL}/dashboard`,
    title: "Dashboard",
    type: "private",
  },

  AGRONOMIST_MANAGEMENT: {
    accessible: true,
    component: <AgronomistManagement />,
    exact: true,
    path: `${AdminBaseURL}/agronomist-management`,
    title: "Agronomist Management",
    type: "private",
  },
  AGRONOMIST_DETAIL: {
    accessible: true,
    component: <AgronomistDetail />,
    exact: true,
    path: `${AdminBaseURL}/agronomist-management/agronomist-detail`,
    title: "Agronomist Detail",
    type: "private",
  },
  SCOUTING_MANAGEMENT: {
    accessible: true,
    component: <ScoutingManagement />,
    exact: true,
    path: `${AdminBaseURL}/scouting-management`,
    title: "Scouting Management",
    type: "private",
  },
  SCOUTING_DETAIL: {
    accessible: true,
    component: <ScoutingDetail />,
    exact: true,
    path: `${AdminBaseURL}/agronomist-management/agronomist-detail/grower-detail/scouting-detail`,
    title: "Scouting Detail",
    type: "private",
  },
  CROP_MANAGEMENT: {
    accessible: true,
    component: <CropManagement />,
    exact: true,
    path: `${AdminBaseURL}/crop-management`,
    title: "Crop Management",
    type: "private",
  },
  CROP_PLAN_MANAGEMENT: {
    accessible: true,
    component: <CropPlanManagement />,
    exact: true,
    path: `${AdminBaseURL}/crop-plan-management`,
    title: "Crop Plan Management",
    type: "private",
  },
  CROP_PLAN_DETAIL: {
    accessible: true,
    component: <CropPlanDetail />,
    exact: true,
    path: `${AdminBaseURL}/agronomist-management/agronomist-detail/grower-detail/crop-plan-detail`,
    title: "Crop Plan Detail",
    type: "private",
  },
  GROWERS_MANAGEMENT: {
    accessible: true,
    component: <GrowerManagement />,
    exact: true,
    path: `${AdminBaseURL}/growers-management`,
    title: "Growers Management",
    type: "private",
  },
  GROWERS_DETAIL: {
    accessible: true,
    component: <GrowerDetail />,
    exact: true,
    path: `${AdminBaseURL}/agronomist-management/agronomist-detail/grower-detail`,
    title: "Growers Detail",
    type: "private",
  },
  PRODUCT_MANAGEMENT: {
    accessible: true,
    component: <ProductManagement />,
    exact: true,
    path: `${AdminBaseURL}/product-management`,
    title: "Product Management",
    type: "private",
  },
  CONTENT_MANAGEMENT: {
    accessible: true,
    component: <ContentManagement />,
    exact: true,
    path: `${AdminBaseURL}/content-management`,
    title: "Content Management",
    type: "private",
  },
};

export { AdminRoutePath };
